import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	bulkEditButton: {
		id: 'issue.views.common.child-issues-panel.child-issues-limit-panel.bulk-edit-button',
		defaultMessage: 'Bulk edit',
		description: 'An action link to go begin the bulk edit process for these issues',
	},
});
